<script>
    import ResetPassword from "../../Pages/Auth/ResetPwd.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <ResetPassword />
</div>
